module.exports = __webpack_public_path__ + "img/four4Red.3132e310.jpg";